const condo_sec1_part1Location = payload => {
  return {
    type: "condosec1part1loc",
    payload
  };
};

export default condo_sec1_part1Location;
